import React, { Component } from 'react';

class Gallery extends Component {
    constructor(props) {
        super(props);
        let data = props.data;
        let images = data.images;

        this.state = {
            images: images,
            count: data.imageCount,
            counter: 1,
        };

        this.nextPhoto = this.nextPhoto.bind(this);
        this.previousPhoto = this.previousPhoto.bind(this);
    };

    nextPhoto() {
        const count = this.state.count;
        const counter = this.state.counter;

        if (counter === Number(count)) {
            this.setState({
                counter: 1,
            })
        } else if (counter < count) {
            this.setState({
                counter: counter + 1,
            })
        }
    }

    previousPhoto() {
        const count = this.state.count;
        const counter = this.state.counter;

        if (counter === 1) {
            this.setState({
                counter: count,
            })
        } else {
            this.setState({
                counter: counter - 1,
            })
        }
    }

    render() {
        const overlay = {
            backgroundColor: 'RGBA(5, 5, 5, 0.90)',
            position: 'absolute',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            zIndex: '10000',
        };

        const close = {
            position: 'absolute',
            top: '5%',
            right: '50px',
        };

        const left = {
            position: 'absolute',
            top: '45%',
            left: '50px',
        };

        const right = {
            position: 'absolute',
            top: '45%',
            right: '50px',
        };

        return (
            <div className="container-fluid d-flex flex-column justify-content-center" style={overlay}>
                <div className="row">
                    <div className="mx-auto col-xs-10 col-md-8">
                        <img className="img-fluid" src={this.state.images[this.state.counter]} alt="project"/>
                    </div>
                </div>
                <button style={left} className="link-button" onClick={this.previousPhoto}><i className="fa fa-chevron-left fa-2x" aria-hidden="true" ></i></button>
                <button style={right} className="link-button" onClick={this.nextPhoto}><i className="fa fa-chevron-right fa-2x" aria-hidden="true" ></i></button>
                <button style={close} className="link-button gallery-close-button" onClick={this.props.clickHandler}><i className="fa fa-times fa-2x" aria-hidden="true" ></i></button>
            </div>
        );
    }
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/modal/gallery.js